function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "search-delete");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7,8.67l4,4a1.25,1.25,0,0,0,1.76,0h0a1.25,1.25,0,0,0,0-1.76l-4-4,4-4a1.25,1.25,0,0,0,0-1.76h0a1.25,1.25,0,0,0-1.76,0l-4,4h.1l-4-4a1.25,1.25,0,0,0-1.76,0h0a1.25,1.25,0,0,0,0,1.76l4,4-4,4a1.25,1.25,0,0,0,0,1.76h0a1.25,1.25,0,0,0,1.76,0l4-4Z",
  fill: "#202144"
});

var SvgSearchDelete = function SvgSearchDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-delete.5ae2c774.svg";
export { ForwardRef as ReactComponent };